import { EnumNgTagInputEditModes } from './tag-input.interface';


/**------------------------------------------------------
 * Configuration Constants
 */
export const NG_TAG_INPUT_MODES: INgTagInputModes = {
	[EnumNgTagInputEditModes.TagInput] : {
		addNew 		: true,
		customTag 	: true,
		edit 		: true,
		remove 		: true,
		draggable 	: true
	},
	[EnumNgTagInputEditModes.Readonly] : {
		addNew 		: false,
		customTag 	: false,
		edit 		: false,
		remove 		: false,
		draggable 	: false
	},
	[EnumNgTagInputEditModes.SelectionInput] : {
		addNew 		: true,
		customTag 	: false,
		edit 		: false,
		remove 		: true,
		draggable 	: true
	},
	[EnumNgTagInputEditModes.ReorderTags] : {
		addNew 		: false,
		customTag 	: false,
		edit 		: false,
		remove 		: false,
		draggable 	: true
	}
};


/**------------------------------------------------------
 * Interfaces Definitions
 */
export interface INgTagInputModes {
	[EnumNgTagInputEditModes.TagInput] 		: INgTagInputModeConfig;
	[EnumNgTagInputEditModes.Readonly] 		: INgTagInputModeConfig;
	[EnumNgTagInputEditModes.SelectionInput]: INgTagInputModeConfig;
	[EnumNgTagInputEditModes.ReorderTags] 	: INgTagInputModeConfig;
}

export interface INgTagInputModeConfig {
	addNew 		: boolean;
	customTag 	: boolean;
	edit 		: boolean;
	remove 		: boolean;
	draggable 	: boolean;
}
